
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PageHeadContainer extends Vue {
  @Prop({ type: String, default: undefined }) readonly title?: string;
}
